import React from "react";
import ResponsiveAppBar from "./responsive-app-bar";
import {Container, Typography} from "@mui/material";
import Spacer from "./Spacer";
import Footer from "./home/Footer";

function CompanyNotFound(){
    return (<>
        <ResponsiveAppBar showLogin={false}/>
        <Container maxWidth={"md"}>
            <Spacer height={50}/>
            <Typography align={"center"}>
                Company not found. Please check document number.
            </Typography>
        </Container>
        <Spacer height={250}/>
        <Footer/>

    </>);
}

export default CompanyNotFound;